import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Input, Text } from "@fragments";
import { Person as PersonIcon } from "@mui/icons-material";
import { UserAvatar } from "@components/Community";
import api from "@helpers/api";
import { useAuth } from "@contexts/AuthContext";

export default function LessonOwner({ value, onChange, community }) {
    const { t } = useTranslation("contentModals");
    const { user } = useAuth();
    const [owners, setOwners] = useState([]);
    const [loading, setLoading] = useState(false);

    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleUpdate = (val) => {
        setLocalValue(val);
        onChange?.(val);
    };

    useEffect(() => {
        fetchCommunityAdmins();
    }, []);

    useEffect(() => {
        console.log(localValue, owners, user)
        if (owners.length > 0 && !localValue) {
            const defaultOwner = owners.find(o => o.id === user?.id) || owners[0];
            handleUpdate(defaultOwner.id);
        }
    }, [owners, localValue, user?.id]);

    const fetchCommunityAdmins = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("roles[]", "owner");
            params.append("roles[]", "creator");
            params.append("per_page", "100");

            const { data } = await api.get(`community/${community}/members/list?${params.toString()}`);

            const members = Array.isArray(data?.data) ? data.data : [];
            const admins = members.map(m => ({
                id: m.user_id,
                username: m.username,
                nickname: m.nickname,
                avatar: m.avatar,
            }));

            let updatedOwners = admins;
            if (user && !admins.some(o => o.id === user.id)) {
                updatedOwners = [user, ...admins];
                setOwners(updatedOwners);
            } else {
                setOwners(admins);
            }

            if (updatedOwners.length > 0 && !localValue) {
                const defaultOwner = updatedOwners.find(o => o.id === user?.id) || updatedOwners[0];
                handleUpdate(defaultOwner.id);
            }
        } catch (error) {
            console.error("Error fetching community admins:", error);
            setOwners([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return null;

    if (owners.length === 0) return null;

    const selectedOwner = owners.find(o => o.id === localValue);

    const options = owners.map(owner => ({
        label: owner.username,
        value: owner.id,
        icon: <UserAvatar user={owner} size={24} link={false} />
    }));

    return (
        <>
            <Text.h5
                left={<PersonIcon />}
                value={t("manageContent.fields.owner")}
                className="mb-1"
            />
            <Input.Select
                key={owners?.length}
                value={localValue}
                onInput={handleUpdate}
                options={options}
                start={selectedOwner ? <UserAvatar user={selectedOwner} size={24} link={false} /> : <PersonIcon />}
            />
        </>
    );
}
